import wixData from 'wix-data';
import wixLocationFrontend from 'wix-location-frontend';
$w.onReady(() => {
    // Real-time search as the user types in the search bar.
    $w("#searchBar").onInput(() => {
        performSearch();
    });
    
});

$w("#repeaterSearch").onItemReady(($item, itemData, index) => {
    $item("#viewButton").onClick(() => {
        if (itemData && itemData.lastName && typeof itemData.lastName === "string") {
            const trimmed = itemData.lastName.trim();
            const firstLetter = trimmed.length > 0 ? trimmed.charAt(0) : "א";
            wixLocationFrontend.to(`/death-beyond?key=${encodeURIComponent(firstLetter)}`);   
        }
    });
});


function performSearch() {
    const searchQuery = $w("#searchBar").value.trim();
    if (searchQuery.length > 0) {
        // Apply the filter based on the search query
        $w("#collectionDatasetName").setFilter(
                wixData.filter()
                .contains("name", searchQuery)
                .or(wixData.filter().contains("first_name", searchQuery))
                .or(wixData.filter().contains("last_name", searchQuery))
            )
            .then(() => {
                // console.log("Dataset filtered");
                // Automatically expand the repeater if there are items to display
                updateRepeaterVisibility();
            })
            .catch((err) => {
                console.error("Failed to filter dataset:", err);
                $w("#repeaterSearch").collapse();
                // Show the notFound element if there's an error
                $w("#notFound").show();
            });
    } else {
        // Clear the filter and collapse the repeater if search query is empty
        $w("#collectionDatasetName").setFilter(wixData.filter())
            .then(() => {
                // console.log("Filter cleared");
                $w("#repeaterSearch").collapse();
                // Hide the notFound element when the filter is cleared
                $w("#notFound").hide();
            })
            .catch((err) => {
                console.error("Failed to clear filter:", err);
                $w("#repeaterSearch").collapse();
                // Optionally, hide the notFound element if there's an error
                $w("#notFound").hide();
            });
    }
}

function updateRepeaterVisibility() {
    // Check if the dataset has items to display after filtering
    $w("#collectionDatasetName").getItems(0, 1).then((results) => {
        if (results.totalCount > 0) {
            $w("#repeaterSearch").expand();
            // Hide the notFound element when there are items to display
            $w("#notFound").hide();
        } else {
            $w("#repeaterSearch").collapse();
            // Show the notFound element when there are no items to display
            $w("#notFound").show();
        }
    });
}